var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdditional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.783,54.931v106.108h-9.811V70.874c0-10.02-8.156-18.175-18.175-18.175h-51.141l-0.405-9.811 h67.489C189.387,42.888,194.783,48.297,194.783,54.931z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.84,70.874v106.108h-8.499V80.759c0-7.248-5.899-13.135-13.135-13.135H99.173v-8.793h67.624 C173.444,58.831,178.84,64.24,178.84,70.874z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.306,73.756 92.306,100.566 61.217,100.566 61.217,96.494 87.412,73.756  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.207,73.756H98.953c-0.123,0.319-0.307,0.601-0.515,0.858v29.017 c0,1.692-1.374,3.066-3.066,3.066H61.217v99.412c0,3.863,3.152,7.003,7.015,7.003h88.975c3.863,0,7.003-3.139,7.003-7.003V80.759 C164.209,76.896,161.07,73.756,157.207,73.756z M141.68,188.4H83.758c-1.692,0-3.066-1.374-3.066-3.066s1.374-3.066,3.066-3.066 h57.923c1.692,0,3.066,1.374,3.066,3.066S143.373,188.4,141.68,188.4z M141.68,167.049H83.758c-1.692,0-3.066-1.374-3.066-3.066 c0-1.692,1.374-3.066,3.066-3.066h57.923c1.692,0,3.066,1.374,3.066,3.066C144.746,165.675,143.373,167.049,141.68,167.049z  M141.68,145.697H83.758c-1.692,0-3.066-1.373-3.066-3.066c0-1.692,1.374-3.066,3.066-3.066h57.923 c1.692,0,3.066,1.374,3.066,3.066C144.746,144.323,143.373,145.697,141.68,145.697z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional);
export default __webpack_public_path__ + "static/media/additional.2cb95c4fdeb787a5fc9471de6d822152.svg";
export { ForwardRef as ReactComponent };